import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import type { Props as MobileAppPrimaryOfferBuyFieldWrapperProps } from './MobileAppPrimaryOfferBuyFieldWrapper';
import { MobileAppPrimaryOfferBuyFieldWrapper } from './MobileAppPrimaryOfferBuyFieldWrapper';
import type { Props as WebPrimaryOfferBuyFieldWrapperProps } from './WebPrimaryOfferBuyFieldWrapper';
import { WebPrimaryOfferBuyFieldWrapper } from './WebPrimaryOfferBuyFieldWrapper';
import type { PrimaryOfferBuyFieldWrapper_anyCard } from './__generated__/index.graphql';

export type Props = WebPrimaryOfferBuyFieldWrapperProps &
  MobileAppPrimaryOfferBuyFieldWrapperProps;

export const PrimaryOfferBuyFieldWrapper = (props: Props) => {
  const { isIosApp, isMarketAuthorizedIosApp, isAndroidApp } = useIsMobileApp();
  const {
    flags: { androidEnableInstantBuy = false },
  } = useFeatureFlags();

  if (
    (isIosApp && !isMarketAuthorizedIosApp) ||
    (isAndroidApp && androidEnableInstantBuy)
  )
    return <MobileAppPrimaryOfferBuyFieldWrapper {...props} />;
  return <WebPrimaryOfferBuyFieldWrapper {...props} />;
};

PrimaryOfferBuyFieldWrapper.fragments = {
  anyCard: gql`
    fragment PrimaryOfferBuyFieldWrapper_anyCard on AnyCardInterface {
      slug
      ...WebPrimaryOfferBuyFieldWrapper_anyCard
      ...MobileAppPrimaryOfferBuyFieldWrapper_anyCard
    }
    ${WebPrimaryOfferBuyFieldWrapper.fragments.anyCard}
    ${MobileAppPrimaryOfferBuyFieldWrapper.fragments.anyCard}
  ` as TypedDocumentNode<PrimaryOfferBuyFieldWrapper_anyCard>,
};
